module.exports = __webpack_public_path__ + "static/dinosaur_die-d8abe6e40fccea8445ed51a065500bbe.png";